export default __webpack_public_path__ + "static/media/cake.b41ccd70.png";